import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useListingContext } from '@/context/listing';
import { getDataSet } from '@/utils/GetData';
import EVENTS from '@/utils/Constants/Events';

// Components
import ListingHeader from '@/listing-delonghi/components/filters/ListingHeader';
import FiltersMenuMobile from '@/listing-delonghi/components/filters/FiltersMenuMobile';
import FiltersMenuDesktop from '@/listing-delonghi/components/filters/FiltersMenuDesktop';
import SelectedFiltersMenu from '@/listing-delonghi/components/filters/SelectedFiltersMenu';
import SortMenu from '@/listing-delonghi/components/filters/SortMenu';

// Hooks
import useListingLoad from '@/hooks/listing/useListingLoad';
import useFetchListingData from '@/hooks/listing/useFetchListingData';
import useListingPopstate from '@/hooks/listing/useListingPopstate';
import useListingPagination from '@/hooks/listing/useListingPagination';

const ListingFiltersApp = () => {
  const [isGrid, setGrid] = useState(false);
  const [areFiltersOpen, openFilters] = useState(false);

  // Getting CategoryCode and SortData from JSP
  const { categoryName, categoryCode, sortData, hasLoadMore } = getDataSet(
    '#js-r-entry-del-listing-filters',
  );

  // Hooks
  const { t } = useTranslation();
  const [{ filtersData, selectedFiltersCount }] = useListingContext();

  useListingLoad({ categoryCode, sortData, hasLoadMore });
  useFetchListingData(categoryCode);
  useListingPopstate();
  useListingPagination();

  const addGridViewOnLoad = () => {
    const allProductBoxes = document.querySelectorAll('.js-del-product-box');
    Array.from(allProductBoxes).forEach(productBox => {
      productBox.classList.add('del-product-box--grid-view');
    });
  };

  // OnClick functions
  const toggleGridView = () => {
    const allProductBoxes = document.querySelectorAll('.js-del-product-box');
    Array.from(allProductBoxes).forEach(productBox => {
      if (!isGrid) {
        productBox.classList.add('del-product-box--grid-view');
        DLG.EVE.on(EVENTS.RESULTS.UPDATE, addGridViewOnLoad);
      } else {
        productBox.classList.remove('del-product-box--grid-view');

        DLG.EVE.off(EVENTS.RESULTS.UPDATE);
      }
    });
    setGrid(!isGrid);
  };

  const toggleFilters = () => {
    openFilters(!areFiltersOpen);
  };

  return (
    <div className='del-plp-filters js-del-plp-filters'>
      <ListingHeader
        categoryName={categoryName}
        categoryCount={filtersData.count}
      />
      <div className='del-plp-filters__inner-wrapper'>
        <div className='del-plp-filters__buttons-wrapper'>
          <div className='del-plp-filters__filter-wrapper'>
            <button
              type='button'
              className='del-button del-plp-filters__filter-button'
              onClick={toggleFilters}
            >
              {t('listing:listing.filter.cta.label')}
              {selectedFiltersCount ? ` (${selectedFiltersCount})` : ''}
              <i className='del-plp-filters__filter-button-icon del-icon icon-filter' />
            </button>
            <FiltersMenuDesktop filtersData={filtersData} />
          </div>
          <SortMenu />
          <div className='del-plp-filters__view-wrapper'>
            <button
              type='button'
              className='del-button del-plp-filters__view-button'
              onClick={toggleGridView}
            >
              {t('listing:listing.view.cta.label')}
              <i
                className={`del-plp-filters__view-button-icon del-icon ${
                  isGrid ? 'icon-view-small' : 'icon-view-big'
                }`}
              />
            </button>
          </div>
        </div>

        {selectedFiltersCount ? <SelectedFiltersMenu /> : null}

        {areFiltersOpen ? (
          <FiltersMenuMobile
            toggleFilters={toggleFilters}
            filtersData={filtersData}
          />
        ) : null}
      </div>
    </div>
  );
};

export default ListingFiltersApp;
